import React from 'react';
import {View} from 'MWC';
import PropTypes from 'prop-types';
import tpl from '../templates/payment.jsx';
import {apiback} from '../../../../../config';
import FrameManager from './postmessage/frameManager';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            qr_value: null,
            frame_url: null,
            qr_error: false
        };

        return this;
    }

    componentWillMount() {
        const {match = {}} = this.props,
            type = match.params && match.params.lastPage;
        if (!type) {
            fetch(apiback('API_GET_QR') + '/10')
                .then(response => (response.ok ? response.json() : Promise.reject(response)))
                .then(json => {
                    this.setState({qr_value: json.uuid}, () => {
                        const interval = setInterval(() => {
                            if (this.state.qr_value) {
                                this.checkQr(interval);
                            }
                        }, 5000);
                    });
                })
                .catch(() => {
                    this.setState({qr_error: true});
                });
        }
    }

    getQr() {
        fetch(apiback('API_GET_QR') + '/10')
            .then(response => response.json())
            .then(json => {
                this.setState({qr_value: json.uuid});
            });
    }

    checkQr(interval) {
        const init = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({uuid: this.state.qr_value})
        };
        fetch(apiback('API_CHECK_QR'), init)
            .then(response => response.json())
            .then(json => {
                if (json.status === 'success') {
                    this.setState({frame_url: json.frame_url}, () => clearInterval(interval));
                } else if (json.status === 'expired' || json.status === 'error') {
                    this.getQr();
                }
            });
    }

    iframeLoad(e) {
        FrameManager.registerFrame(e.currentTarget);
    }

    static displayName = 'Payments.Payment';

    static contextTypes = {
        app: PropTypes.object,
        history: PropTypes.object
    };
}
